<template lang="pug">
  v-select.ati-select(:value.sync="selectedOption" @input="onInput" :options='options' placeholder="Select Validation Message")
</template>

<script>
import vSelect from 'vue-select'
import Core from '@/service/apis/Core'

export default {
  data: () => ({
    selectedOption: null,
    options: []
  }),
  created() {
    Core.listAtis()
      .then((resp) => {
        this.options = resp.data.ati.map((o) => {
          const opt = {
            value: o.id,
            label: o.name
          }
          return opt
        })
      })
      .catch((e) => { this.$emit('error', e) })
  },
  methods: {
    onInput(opt) {
      this.$emit('input', opt)
    }
  },
  components: {
    vSelect
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ssp/AtiSelect.vue